import { useGetQuery } from '../../graphql';

// Accepts `string | undefined` to match useParams()'s shape — callers can pass
// the raw issueId without coercing to ''.
export const useIssue = (issueId?: string) => {
  const { data, isLoading } = useGetQuery({
    modelName: 'issue',
    query: GET_ISSUE,
    id: issueId ?? '',
    // Don't fire getIssue without an id. issueId is briefly undefined while a
    // panel slides out (e.g. closing the activity conversation back to the
    // list), and an unguarded query would send { id: "" }, which the backend
    // coerces into a bogus UUID and rejects with "Cannot find a Issue".
    options: { enabled: !!issueId },
  });

  return { issue: data, isLoading };
};

const GET_ISSUE = `
    query getIssue($id: ID!) {
      getIssue(id: $id) {
        id
        title
        type
        severity
        isPinned
        workspace {
          id
          name
        }
        asset {
          id
          name
          description
        }
        createdBy {
          id
          name {
            first
            last
          }
        }
        createdAt
        adjustCreationDate
        updatedAt
        routineVersion {
          config
          createdAt
          id
          order
          type
        }
        location {
          type
          coordinates
        }
        # createdFrom restored: the JOHN_DEERE + GEOTAB enum values are now part
        # of the backend IssueCreationSource enum (GeoTab integration PR, GRIPP
        # #2887), so the serialization error that forced the prior omission no
        # longer applies. Drives the integration attribution tag in the
        # first-message header for auto-synced fault issues.
        createdFrom
        createdFromAddress
        labels {
          id
          name
        }
        userMentions {
          id
          name {
            first
            last
          }
        }
        assetRoutine {
          id
          exceptionCount
          data
          createdFrom
          routineVersion {
            id
            type
            config
          }
          createdAt
          createdBy {
            id
            name {
              first
              last
            }
          }
          routine {
            id
          }
        }
        onboarding {
          nextIssue
        }
      }
    }
`;
